import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/new-subscription')({
  component: () => <Navigate replace search to="/bo/subscriptions/new" />,
})
